
const serverAddress="https://wave-api-services.herokuapp.com/";

export async function createUser(userData){

  let response= await fetch(serverAddress+'create-users', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(userData)
    })
    return await response.json();

}

export async function getAllUser(offset,limit,skip,order,conditions){

  let response= await fetch(serverAddress+'get-all-users?filter={"offset": '+offset+', "limit": '+limit+', "skip": '+skip+', "order": "'+order+'", "where": '+JSON.stringify(conditions)+', "fields": { "id": true, "email": true, "password": true, "walletAddress": true, "phrase": true, "publicKey": true, "privateKey": true }}');
  return await response.json();
}

export async function getUser(conditions){
  let response= await fetch(serverAddress+'get-user', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(conditions)
  })
  return await response.json();
}

export async function updatePassword(objData){
  let response= await fetch(serverAddress+'update-password', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(objData)
  })
  return await response.json();
}

export async function getUserCount(conditions){
  let response= await fetch(serverAddress+'users/count?where='+JSON.stringify(conditions));
  return await response.json();
}